import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { animateToScreen } from '../../redux/ui/actions';
import { setTicketZones } from '../../redux/cardReader/actions';
import { TICKET_TYPE_VALUE_TICKET } from '../../constants';
import { getZoneBackgroundImage } from '../helpers';
import CardReaderScreen from '../../molecules/CardReaderScreen';

class SeasonalTicketRegionRC extends PureComponent {
  render() {
    const { currentZone, previousScreen } = this.props;
    const zoneImg = getZoneBackgroundImage(currentZone);
    const fadeDuration = previousScreen === 'Home' ? '0ms' : '500ms';
    return (
      <CardReaderScreen backgroundImage={zoneImg} fadeDuration={fadeDuration} />
    );
  }
}
SeasonalTicketRegionRC.propTypes = {
  previousScreen: PropTypes.string.isRequired,
  currentZone: PropTypes.string.isRequired,
};

const mapStateToProps = ({ ui, cardReader }) => ({
  previousScreen: ui.previousScreen,
  currentZone: cardReader.currentZone,
});

const mapDispatchToProps = (dispatch) => ({
  goToPurchaseScreen: () => dispatch(animateToScreen('ValueTicketPurchase')),
  setTicketZones: (zones) => dispatch(setTicketZones(TICKET_TYPE_VALUE_TICKET, zones)),  // eslint-disable-line
});

// prettier-ignore
export default connect(mapStateToProps, mapDispatchToProps)(SeasonalTicketRegionRC);
